import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/error-404.png'


const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white text-center error-404-card" }
const _hoisted_2 = { class: "card-body letter-spacing" }
const _hoisted_3 = {
  key: 0,
  style: {"font-size":"45px"}
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, "5", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "😭😭", -1)
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  style: {"font-size":"45px"}
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, "4", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "😭", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, "3", -1)
const _hoisted_11 = [
  _hoisted_8,
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = { key: 2 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "error-image"
}, null, -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "fw-bold text-black" }
const _hoisted_16 = { key: 3 }


export default /*#__PURE__*/_defineComponent({
  __name: 'HttpStatus',
  props: {
  statusCode: { type: Number, required: true },
  detail: { type: String, required: false, default: null },
  endpoint: { type: String, required: false, default: null },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (__props.statusCode === 500)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_6))
        : (__props.statusCode === 403)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_11))
          : (__props.statusCode === 404)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
            : _createCommentVNode("", true),
      _createElementVNode("h1", _hoisted_15, _toDisplayString(__props.detail), 1),
      (__props.endpoint)
        ? (_openBlock(), _createElementBlock("h5", _hoisted_16, _toDisplayString(__props.endpoint), 1))
        : _createCommentVNode("", true),
      (__props.statusCode === 404)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 4,
            class: "default-btn transition text-decoration-none border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success",
            to: { name: 'home' }
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Back To Home ")
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})